export default __webpack_public_path__ + "static/media/yellow-cross.1b8b8413.svg";